import { useEffect, useState, useContext } from 'react';
import CommonTable from '../common/commonTable/CommonTable';
import UnitModal from './UnitModal';
import ReactNotifications from '../common/reactNotifications/ReactNotifications';
import * as utilConstants from "../../utils/constants/utilsConstants";
import DeleteModal from '../common/commonModal/DeleteModal';
import PaginationComponent from '../common/pagination/Pagination';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { unitCrud } from '../../api/UnitsApi';
import Context from '../../context/Context';

const Units = ({ filters: propFilters, setFilters: propSetFilters, disableTitleUpdate }) => {
    const [unitsData, setUnitsData] = useState([]);
    const { setPageTitle } = useContext(Context);
    const location = useLocation();
    const navigate = useNavigate();

    const [internalFilters, setInternalFilters] = useState({});
    const filters = propFilters !== undefined ? propFilters : internalFilters;
    const setFilters = propSetFilters !== undefined ? propSetFilters : setInternalFilters;

    const columns = [
        { header: 'ID', accessor: 'id' },
        { header: 'Unit', accessor: 'name' },
    ];
    
    const [showUnitModal, setShowUnitModal] = useState(false);
    const [editingUnit, setEditingUnit] = useState(null);
    
    const [showDelModal, setShowDelModal] = useState(false);
    const [delRow, setDelRow] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);

    const itemsPerPage = 10;
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const { searchQuery } = location.state || {};
        if (searchQuery) {
            setFilters({ search: searchQuery });
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, navigate, setFilters]);

    const handlePageChange = (page) => {
        setSearchParams({ p: page });
        setCurrentPage(page);
    };

    const handleDeleteClick = (row) => {
        setDelRow(row);
        setShowDelModal(true);
    };

    const handleDelete = (row) => {
        if (delRow?.id) {
            unitCrud(delRow, 'delete', (res) => {
                if (res?.status === true) {
                    ReactNotifications(res?.message, utilConstants.sucessState200);
                    fetchAllUnits(currentPage, filters);
                    setShowDelModal(false);
                } else {
                    ReactNotifications(res?.data?.message, utilConstants.getErrorStatus);
                }
            })
        }
    };

    const handleAddClick = () => {
        setEditingUnit(null);
        setShowUnitModal(true);
    };

    const handleEditClick = (row) => {
        setEditingUnit(row);
        setShowUnitModal(true);
    };

    const handleModalSaveSuccess = () => {
        const pageToFetch = editingUnit ? currentPage : 1;
        fetchAllUnits(pageToFetch, filters);
    };

    const fetchAllUnits = (page, appliedFilters) => {
        setLoading(true);
        const payload = { page, ...appliedFilters };
        unitCrud(payload, 'get', (response) => {
            if (response?.status === true) {
                setTotalCount(response?.count);
                setUnitsData(response?.data);
            }
            setLoading(false);
            setHasFetched(true);
        });
    }

    useEffect(() => {
        if (!disableTitleUpdate) {
            setPageTitle('Units');
        }
        const pageFromUrl = parseInt(searchParams.get('p')) || 1;
        setCurrentPage(pageFromUrl);
    }, [setPageTitle, searchParams, disableTitleUpdate]);

    useEffect(() => {
        fetchAllUnits(currentPage, filters);
    }, [currentPage, filters]);

    return (
        <section>
            <div className='px-4'>
                <CommonTable
                    columns={columns}
                    data={unitsData}
                    actions={['edit', 'delete']}
                    onAdd={handleAddClick}
                    onEdit={handleEditClick}
                    onDelete={handleDeleteClick}
                    addButtonText="Add"
                    loading={loading}
                    hasFetched={hasFetched}
                    isExport={false}
                    idAccessor="id"
                />
                {totalCount > 10 && <PaginationComponent
                    currentPage={currentPage}
                    totalCount={totalCount}
                    itemsPerPage={itemsPerPage}
                    onPageChange={handlePageChange}
                />}
                <UnitModal
                    show={showUnitModal}
                    onHide={() => setShowUnitModal(false)}
                    initialData={editingUnit}
                    onSaveSuccess={handleModalSaveSuccess}
                />
                <DeleteModal
                    show={showDelModal}
                    onClose={() => setShowDelModal(false)}
                    onConfirm={handleDelete}
                    title="Delete Unit"
                    message="Are you sure you want to delete this unit? This action cannot be undone."
                />
            </div>
        </section>
    )
}

export default Units;